/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_a5e003a7{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_a5e003a7{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_a5e003a7{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n"}]);
export const root = "root_a5e003a7";
export const rootVertical = "rootVertical_a5e003a7";
export const item = "item_a5e003a7";